import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageBreadcrumbs, { PageBreadcrumbsStyles } from "@insite/content-library/Components/PageBreadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

export interface BreadcrumbsStyles {
    pageBreadcrumbs?: PageBreadcrumbsStyles;
}

export const breadcrumbStyles: BreadcrumbsStyles = {
    pageBreadcrumbs: {
        breadcrumbs: {
            css: css`
                padding-bottom: 30px;
                
                 ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                &&&[data-test-selector="pageBreadcrumbs"] > :not(:nth-last-child(-n+3)) {
                                    display: none;

                                }
                            `,
                            css`
                                &&&[data-test-selector="pageBreadcrumbs"] > :not(:nth-last-child(-n+3)) {
                                    display: flex;

                                }
                            `,
                            css`
                                &&&[data-test-selector="pageBreadcrumbs"] > :not(:nth-last-child(-n+3)) {
                                    display: flex;

                                }
                            `,
                            css`
                                &&&[data-test-selector="pageBreadcrumbs"] > :not(:nth-last-child(-n+3)) {
                                    display: flex;

                                }
                            `,
                            css`
                                &&&[data-test-selector="pageBreadcrumbs"] > :not(:nth-last-child(-n+3)) {
                                    display: flex;

                                }
                            `,
                        ],
                        "min"
                    )}
            `,
        },
    },
};

export const Breadcrumbs: FC<WidgetProps> = () => {
    return <PageBreadcrumbs extendedStyles={breadcrumbStyles.pageBreadcrumbs} />;
};

const widgetModule: WidgetModule = {
    component: Breadcrumbs,
    definition: {
        group: "Basic",
        icon: "chevrons-right",
    },
};

export default widgetModule;
